export default __webpack_public_path__ + "static/slider1-d180736f3ae10079d0612329bc640e75.jpg";